// Desktop only: below the large-desktop breakpoint the sidebar is always a drawer.
const SIDEBAR_MODES = ['docked', 'folded'] as const

const DEFAULT_SIDEBAR_MODE = 'docked'

export { DEFAULT_SIDEBAR_MODE, SIDEBAR_MODES }
